import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../action/notifications/notifications';
import { EMPLOYEE_STATUS } from '../../employees/actions/load-org-employees-by-status';
import { setOrgEmployeesDirty } from '../../employees/actions/set-org-employees-dirty';

import { post } from '../../api/api';

import { capitalize } from '../../util/formatters';
import { MERGE_SYNC_STATUS } from '../util/merge-sync-status';

export const updateMergeIntegration = (orgId: number, update: Partial<MergeIntegration>) =>
  createGenericDispatcher({
    name: 'UPDATE_MERGE_INTEGRATION',
    loadFunction: () => post(`/merge?orgId=${orgId}`, { body: JSON.stringify(update) }),
    args: { orgId },
    onSuccess: (dispatch) => {
      let verb;
      let shouldSetEmployeesDirty = true;
      if (update.syncStatus === MERGE_SYNC_STATUS.IMPORT_PAUSED) {
        verb = 'pause';
      } else if (update.syncStatus === MERGE_SYNC_STATUS.SYNCING) {
        verb = 'resume';
      } else {
        shouldSetEmployeesDirty = false;
        verb = 'update';
      }
      dispatch(
        addNotificationAction({
          key: `${verb}-merge-integration-${orgId}`,
          message: `${capitalize(verb)}d integration`,
        }),
      );
      if (shouldSetEmployeesDirty) {
        dispatch(setOrgEmployeesDirty(orgId, EMPLOYEE_STATUS.CURRENT));
        dispatch(setOrgEmployeesDirty(orgId, EMPLOYEE_STATUS.FORMER));
      }
    },
  });
